import React from 'react';
import cn from 'classnames';
import { stageGrotesk } from '@/app/fonts';
import { ThemeProvider } from '@/app/providers/ThemeProvider';
import { StoreProvider } from '@/app/providers/StoreProvider';
import { RouterProvider } from '@/app/providers/RouterProvider';
import { useChatSocketLifecycle } from '@/features/Chat';
import { FloatingProvider } from '@/shared/lib/components/FloatingProvider';

// Сокет живёт выше <Routes>: внутри ProtectedRoute он умирал на переходе между
// разделами вместе с уровнем маршрута, унося с собой обработчики chat:*.
const ChatSocketLifecycle = () => {
  useChatSocketLifecycle();
  return null;
};

function App() {
  return (
    <FloatingProvider>
      <ThemeProvider>
        <StoreProvider>
          <div className={cn(stageGrotesk.variable, 'app')}>
            <ChatSocketLifecycle />
            <RouterProvider />
          </div>
        </StoreProvider>
      </ThemeProvider>
    </FloatingProvider>
  );
}

export default App;
